<svg:g role="button" attr.transform="translate({{-totalW/2}}, 0)">
@if(id) {
    <svg:rect [attr.x]="-padding/2" y="0" [attr.width]="idW" [attr.height]="height" fill="silver"></svg:rect>
    <svg:text #idText x="0" y="10" dominant-baseline="middle" fill="white">{{ id }}</svg:text>
}

@if(mod) {
    <svg:rect [attr.x]="modX - padding/2" [attr.width]="modW" [attr.height]="height" fill="lavender"></svg:rect>
    <svg:text #modText [attr.x]="modX" y="10" dominant-baseline="middle">{{ mod }}</svg:text>
}

@if(sign != null) {
    <svg:rect [attr.x]="headX" [attr.width]="headW" [attr.height]="height" [attr.fill]="sign === true ? 'honeydew' : 'mistyrose'"></svg:rect>
}

@if(end) {
    <svg:circle [attr.cx]="totalW / 2" [attr.cy]="11" r="10" fill="salmon"/>
    <svg:text #headText [attr.x]="totalW / 2 - 8.25" y="11.5625" dominant-baseline="middle" font-weight="bold" fill="white">{{rule ? '⛌' : '⭘'}}</svg:text>
}
@else {
    <svg:text #headText [attr.x]="headX" y="10" dominant-baseline="middle">{{ head }}</svg:text>
}

@if(args) {
    <svg:rect [attr.x]="argsX - padding/2" [attr.width]="argsW" [attr.height]="height" fill="khaki"></svg:rect>
    <svg:text #argsText [attr.x]="argsX" y="10" dominant-baseline="middle">{{ args }}</svg:text>
}

@if(rule || end) {
<svg:text #ruleText [attr.x]="totalW/2" y="30" style="font-size:.8em;" text-anchor="middle" dominant-baseline="middle">{{ rule || 'Open branch' }}</svg:text>
}

</svg:g>
